import { useEffect } from 'react';
import Header from '../../../components/base/Header';
import Footer from '../../../components/base/Footer';
import { Link } from 'react-router-dom';

export default function WinterPoinsettiaBlog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-rose-50 to-orange-50">
      <Header />

      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-r from-red-600 via-rose-600 to-amber-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block mb-6">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-gift-2-line text-5xl text-white"></i>
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              【第2弾】季節の花の楽しみ方：ポインセチア編
            </h1>
            <p className="text-xl text-white/90 mb-6">
              ──クリスマスを彩る、気品ある赤い花──
            </p>
            <div className="flex items-center justify-center gap-4 text-white/90">
              <span className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                2025年11月5日
              </span>
              <span className="flex items-center">
                <i className="ri-user-line mr-2"></i>
                アルバート
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/cf1c35499a6d82530cf5d4aad867c56a.jpeg"
                alt="アルバート"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            {/* Introduction */}
            <div className="mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                ごきげんよう、モモちゃん畑のアルバートです。<br />
                本日は、冬の花の中でも特に気品あふれる<br />
                <span className="font-bold text-red-700">ポインセチア</span> についてお話しさせていただきます。
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                クリスマスシーズンになると、街中で見かけるこの美しい赤い花。<br />
                その華やかさと優雅さは、まさに冬の王者と呼ぶにふさわしい存在です。<br />
                私アルバートが、その魅力を余すことなくご紹介いたしましょう。
              </p>
            </div>

            {/* Section 1 */}
            <div className="mb-12 bg-gradient-to-br from-red-50 to-rose-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-red-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">👑</span>
                ポインセチアの魅力──冬の王者たる所以
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ポインセチアは、メキシコ原産の常緑低木。<br />
                  その鮮やかな赤と緑のコントラストは、<br />
                  まさにクリスマスカラーそのものです。
                </p>
                <p>
                  実は、あの美しい赤い部分は花ではなく<br />
                  <span className="font-bold text-red-700">「苞（ほう）」</span>と呼ばれる葉なのです。<br />
                  本当の花は、中央の小さな黄色い部分。
                </p>
                <div className="bg-white rounded-2xl p-6 my-6 border-l-4 border-red-400">
                  <p className="text-red-700 font-medium text-lg">
                    この知識を知っているだけで、<br />
                    あなたもポインセチア通として<br />
                    一目置かれる存在になれるでしょう。
                  </p>
                </div>
                <p className="font-medium text-red-800">
                  ポインセチアの歴史は古く、<br />
                  17世紀にメキシコで発見されて以来、<br />
                  世界中で愛され続けています。
                </p>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-12 bg-gradient-to-br from-amber-50 to-yellow-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-amber-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🎨</span>
                ポインセチアの色の秘密
              </h2>
              <h3 className="text-xl font-bold text-amber-700 mb-6">
                ──赤だけではない、多彩なバリエーション
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ポインセチアといえば赤が定番ですが、<br />
                  実は様々な色のバリエーションが存在します。
                </p>
                <div className="grid md:grid-cols-3 gap-4 my-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">🔴</div>
                    <h3 className="text-lg font-bold text-red-600 mb-2">クラシックレッド</h3>
                    <p className="text-sm text-gray-600">伝統的な赤色<br />最も人気</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">🤍</div>
                    <h3 className="text-lg font-bold text-gray-600 mb-2">ホワイト</h3>
                    <p className="text-sm text-gray-600">清楚で上品<br />純白の美しさ</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">🩷</div>
                    <h3 className="text-lg font-bold text-pink-600 mb-2">ピンク</h3>
                    <p className="text-sm text-gray-600">優しい雰囲気<br />可愛らしい</p>
                  </div>
                </div>
                <p>
                  さらに、マーブル模様や斑入りなど、<br />
                  個性的な品種も次々と登場しています。
                </p>
                <div className="bg-white rounded-2xl p-6 my-6">
                  <p className="text-gray-700">
                    私のおすすめは、<br />
                    <span className="font-bold text-amber-700">クラシックレッドとホワイトを組み合わせた飾り方</span>。<br />
                    気品と清潔感が同時に演出できます。
                  </p>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-12 bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-green-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌱</span>
                優雅に育てる──ポインセチアの3つのポイント
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ポインセチアは、適切な管理をすれば<br />
                  長く美しい姿を保つことができます。<br />
                  私が実践している育て方のコツをお教えしましょう。
                </p>
                <div className="space-y-6 my-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                        <span className="text-2xl font-bold text-green-700">①</span>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-green-800 mb-2">
                          温度管理は15～25℃を保つ
                        </h3>
                        <p className="text-gray-700">
                          メキシコ原産のため、寒さは苦手です。<br />
                          暖房の効いた室内で、窓際の冷気を避けて管理しましょう。<br />
                          10℃以下になると葉が落ちてしまいます。
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                        <span className="text-2xl font-bold text-green-700">②</span>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-green-800 mb-2">
                          水やりは土の表面が乾いてから
                        </h3>
                        <p className="text-gray-700">
                          過湿を嫌うため、水のやりすぎは禁物。<br />
                          土の表面が乾いたら、鉢底から水が流れ出るまで<br />
                          たっぷりと与えるのが基本です。
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                        <span className="text-2xl font-bold text-green-700">③</span>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-green-800 mb-2">
                          日当たりの良い場所に置く
                        </h3>
                        <p className="text-gray-700">
                          美しい色を保つには、十分な日光が必要です。<br />
                          ただし、直射日光は避け、<br />
                          レースカーテン越しの明るい場所が理想的です。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="font-medium text-green-800 text-lg text-center">
                  この3つを守れば、<br />
                  クリスマスから春先まで美しさを楽しめます。
                </p>
              </div>
            </div>

            {/* Section 4 */}
            <div className="mb-12 bg-gradient-to-br from-rose-50 to-pink-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-rose-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🎄</span>
                クリスマスを彩る飾り方のアイデア
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ポインセチアは、その存在だけで空間を華やかにしますが、<br />
                  少しの工夫でさらに魅力的な演出ができます。
                </p>
                <div className="space-y-6 my-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-rose-700 mb-3 flex items-center">
                      <span className="mr-2">✨</span>
                      ゴールドのリボンで気品をプラス
                    </h3>
                    <p className="text-gray-700">
                      鉢にゴールドのリボンを巻くだけで、<br />
                      一気に高級感が増します。<br />
                      王室御用達の雰囲気を演出できますよ。
                    </p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-rose-700 mb-3 flex items-center">
                      <span className="mr-2">🕯️</span>
                      キャンドルと組み合わせる
                    </h3>
                    <p className="text-gray-700">
                      ポインセチアの周りに白いキャンドルを配置すると、<br />
                      ロマンティックなクリスマスの雰囲気に。<br />
                      ディナーテーブルの演出に最適です。
                    </p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-rose-700 mb-3 flex items-center">
                      <span className="mr-2">🎁</span>
                      複数の鉢を並べて豪華に
                    </h3>
                    <p className="text-gray-700">
                      赤・白・ピンクのポインセチアを並べると、<br />
                      まるで花のブーケのような華やかさ。<br />
                      玄関やリビングの主役になります。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 5 */}
            <div className="mb-12 bg-gradient-to-br from-red-50 to-amber-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-red-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">💐</span>
                ポインセチアの花言葉
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ポインセチアの花言葉は、<br />
                  <span className="font-bold text-red-700">「祝福」「聖夜」「私の心は燃えている」</span>。
                </p>
                <p>
                  クリスマスにふさわしい、<br />
                  温かく情熱的な言葉ばかりです。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-red-200">
                  <p className="text-2xl font-bold text-red-800 mb-4">
                    「祝福」の花言葉は、<br />
                    大切な人への贈り物に最適
                  </p>
                  <p className="text-lg text-gray-700">
                    クリスマスプレゼントとして贈れば、<br />
                    あなたの温かい気持ちが伝わるでしょう。
                  </p>
                </div>
                <p className="font-medium text-red-800">
                  また、赤いポインセチアには<br />
                  「私の心は燃えている」という情熱的な花言葉も。<br />
                  特別な方への贈り物にいかがでしょうか。
                </p>
              </div>
            </div>

            {/* Section 6 */}
            <div className="mb-12 bg-gradient-to-br from-amber-50 to-yellow-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-amber-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌟</span>
                アルバートからのメッセージ
              </h2>
              <h3 className="text-xl font-bold text-amber-700 mb-6">
                ──優雅な冬の時間を、ポインセチアと共に
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ポインセチアは、ただ美しいだけではありません。<br />
                  その気品ある佇まいは、<br />
                  私たちに優雅な時間の過ごし方を教えてくれます。
                </p>
                <p>
                  クリスマスシーズンの慌ただしさの中で、<br />
                  ポインセチアを眺めながら<br />
                  ゆったりとした時間を過ごす。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-amber-200">
                  <p className="text-2xl font-bold text-amber-800 mb-4">
                    それこそが、<br />
                    真の贅沢というものです。
                  </p>
                  <p className="text-lg text-gray-700">
                    あなたも今年のクリスマスは、<br />
                    ポインセチアと共に優雅な時間を<br />
                    お過ごしになってはいかがでしょうか。
                  </p>
                </div>
                <p className="text-center text-lg font-medium text-amber-700">
                  それでは、ごきげんよう。<br />
                  素敵なクリスマスシーズンをお過ごしください🎄
                </p>
              </div>
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mb-12">
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #ポインセチア
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #クリスマス
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #季節の花
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #育て方
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #花言葉
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #アルバート
              </span>
            </div>

            {/* Back Button */}
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center bg-gradient-to-r from-red-600 to-amber-600 hover:from-red-700 hover:to-amber-700 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                エッセイ一覧に戻る
              </Link>
            </div>
          </div>
        </div>
      </article>

      {/* Related Posts */}
      <section className="py-16 bg-gradient-to-br from-pink-50 to-rose-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-rose-800 mb-8 text-center">
              他のブログ記事も読む
            </h2>
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center text-rose-600 hover:text-rose-700 font-medium transition-colors"
              >
                すべての記事を見る
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
